import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DatePicker, Empty, Popconfirm, Select } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import api from "../Interceptor";
import { getRoute } from "../api/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import CustomModal from "../components/customModal/customModal";
import CompanyInfo from "../components/CompanyInfo";
import useModal from "../hooks/useModal";
import { useSelector, useDispatch } from "react-redux";
import { setProjectList } from "../slices/app";

const { Option } = Select;

const Invoice = () => {
  const [invoices, setInvoices] = useState([]);
  // const [projectInvoices, setProjectInvoices] = useState([]);
  const [invoiceType, setInvoiceType] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const companyName = localStorage.getItem("companyName");
  const companyLogo = localStorage.getItem("companyLogo");
  const companyAbout = localStorage.getItem("companyAbout");
  const [companyInfo] = useState(
    !!(companyName && companyLogo && companyAbout),
  );
  const { isOpen, toggleModal } = useModal();
  const companyId = localStorage.getItem("companyId");
  // const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  // const toggleCompanyModal = () => setIsCompanyModalOpen((prev) => !prev);
  const dispatch = useDispatch();
  const totalInvoicesCount = invoices.length;

  const projectInvoicesCount = invoices.filter(
    (inv) => inv.invoiceType === "projectInvoice",
  ).length;

  const generalInvoicesCount = invoices.filter(
    (inv) => inv.invoiceType === "generalInvoice",
  ).length;

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        getRoute("users", "admin", "projects", false, false, ""),
      );
      const data = response.data;
      if (Array.isArray(data)) {
        dispatch(setProjectList(response.data));
        setLoading(false);
      } else {
        throw new Error("Projects data is not in the expected format");
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      const errorMessage =
        error.response?.data?.message || "Failed to load projects";
      toast.error(errorMessage);
    }
  };
  const fetchInvoices = async () => {
    try {
      setLoading(true);

      const [generalResponse, projectResponse] = await Promise.all([
        api.get(getRoute("users", "admin", "invoices", false, true)),
        api.get(getRoute("users", "admin", "projectInvoices", false, true)),
      ]);

      const generalInvoices = generalResponse.data.map((inv) => ({
        ...inv,
        invoiceType: "generalInvoice",
      }));

      const projectInvoices = projectResponse.data.map((inv) => ({
        ...inv,
        invoiceType: "projectInvoice",
      }));

      const combined = [...generalInvoices, ...projectInvoices].sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      );

      setInvoices(combined);
      setFilteredInvoices(combined);
    } catch (error) {
      toast.error("Oops! Error while fetching invoices");
    } finally {
      setLoading(false);
    }
  };

  // const fetchProjectInvoices = async () => {
  //   try {
  //     const response = await api.get(
  //       `${getRoute('users', 'admin', 'projectInvoices', false, true)}`
  //     );

  //     const reversedInvoices = response.data.reverse();
  //     setProjectInvoices(reversedInvoices);
  //     setFilteredInvoices(reversedInvoices);
  //     setLoading(false);
  //   } catch (error) {
  //     if (error?.isUnpaid) {
  //       return;
  //     }
  //     toast.error('Oops! Error while fetching Invoices');
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    // setFilteredInvoices([]);
    // if (invoiceType === 'generalInvoice') {
    fetchInvoices();
    // } else {
    // fetchProjectInvoices();
    fetchProjects();
    // }
  }, []);

  useEffect(() => {
    const handleAiRefreshInvoices = () => {
      fetchInvoices();
      fetchProjects();
    };
    window.addEventListener("ai:refreshInvoices", handleAiRefreshInvoices);
    return () => {
      window.removeEventListener("ai:refreshInvoices", handleAiRefreshInvoices);
    };
  }, []);
  useEffect(() => {
    let data = [...invoices];

    if (invoiceType) {
      data = data.filter((inv) => inv.invoiceType === invoiceType);
    }

    if (filterDate) {
      const selectedDate = dayjs(filterDate).format("YYYY-MM-DD");
      data = data.filter(
        (inv) => dayjs(inv.date).format("YYYY-MM-DD") === selectedDate,
      );
    }

    if (statusFilter) {
      data = data.filter((inv) => inv.status === statusFilter);
    }

    setFilteredInvoices(data);
  }, [invoiceType, statusFilter, filterDate, invoices]);

  const handleNewInvoiceClick = () => {
    navigate("/createInvoice", { state: { invoiceCount: invoices.length } });
  };
  // const handleEditInvoice = (id) => {
  //   const navigateTo =
  //     invoiceType === 'generalInvoice' ? '/editInvoice' : '/editProjectInvoice';
  //   navigate(navigateTo, {state: {invoiceId: id}});
  // };
  const handleViewInvoice = (invoice) => {
    navigate(
      invoice.invoiceType === "generalInvoice" ? "/invoice" : "/projectInvoice",
      { state: { invoiceId: invoice._id, editMode: false } },
    );
  };
  const handleEditInvoice = (invoice) => {
    navigate(
      invoice.invoiceType === "generalInvoice" ? "/invoice" : "/projectInvoice",
      { state: { invoiceId: invoice._id, editMode: true } },
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleFilterDateChange = (date) => {
    setFilterDate(date);
  };

  // const filterInvoicesByDate = (selectedDate) => {
  //   if (selectedDate) {
  //     const data =
  //       invoiceType === 'generalInvoice'
  //         ? invoices.filter(
  //             (invoice) =>
  //               new Date(invoice.date).toISOString().slice(0, 10) ===
  //               selectedDate
  //           )
  //         : projectInvoices.filter(
  //             (invoice) =>
  //               new Date(invoice.date).toISOString().slice(0, 10) ===
  //               selectedDate
  //           );
  //     const filteredData = data;
  //     setFilteredInvoices(filteredData);
  //   } else {
  //     setFilteredInvoices(invoices);
  //   }
  // };

  const handleDeleteInvoice = async (invoice) => {
    try {
      const endpoint =
        invoice.invoiceType === "generalInvoice"
          ? `${getRoute("users", "admin", "invoices", false)}?id=${invoice._id}`
          : `${getRoute("users", "admin", "projectInvoices", false)}?id=${
              invoice._id
            }`;

      await api.delete(endpoint);
      await fetchInvoices();
      await fetchProjects();
      toast.success("Invoice deleted successfully");
    } catch {
      toast.error("Failed to delete invoice");
    }
  };

  const handleRefresh = () => {
    setInvoiceType("");
    setStatusFilter("");
    setFilterDate("");
    setFilteredInvoices(invoices);
  };

  const handleDownloadPDF = async () => {
    const input = tableRef.current;

    if (!input) return;

    const actionHeader = input.querySelector("th:nth-child(9)");
    const actionCells = input.querySelectorAll("td:nth-child(9)");

    if (actionHeader) actionHeader.style.display = "none";
    actionCells.forEach((cell) => (cell.style.display = "none"));

    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const imgWidth = 190;
    const pageHeight = pdf.internal.pageSize.height;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 10;

    pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - position;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight + 10;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    if (actionHeader) actionHeader.style.display = "";
    actionCells.forEach((cell) => (cell.style.display = ""));

    pdf.save("InvoiceList.pdf");
  };

  const calculateInvoiceDetails = (invoice) => {
    if (Array.isArray(invoice.items)) {
      const totalBeforeTax = invoice.items.reduce((acc, item) => {
        const itemTotal = item.quantity * item.unitPrice;
        return acc + parseFloat(itemTotal || 0);
      }, 0);

      const taxAmount =
        Array.isArray(invoice.taxes) && invoice.taxes.length > 0
          ? invoice.taxes.reduce((acc, tax) => {
              const taxCalc =
                (totalBeforeTax * parseFloat(tax.rate || 0)) / 100;
              return acc + taxCalc;
            }, 0)
          : 0;

      const totalAfterTax = totalBeforeTax + taxAmount;

      // FIX → Ensure discount is a number and default to 0
      const discountPercentage = Number(invoice.discount) || 0;

      const discountValue = (discountPercentage / 100) * totalBeforeTax;

      const totalAfterDiscount = totalAfterTax - discountValue;

      return {
        totalBeforeTax,
        taxAmount,
        totalAfterTax,
        discount: discountPercentage,
        totalAfterDiscount,
      };
    }

    return {
      totalBeforeTax: 0,
      taxAmount: 0,
      totalAfterTax: 0,
      totalAfterDiscount: 0,
      discount: 0,
    };
  };

  const handleInvoiceTypeChange = (value) => {
    setInvoiceType(value);
  };
  const handleCloneInvoice = async (invoice) => {
    try {
      const isProject = invoice.invoiceType === "projectInvoice";

      const endpoint = isProject
        ? getRoute("users", "admin", "projectInvoices") + "/clone"
        : getRoute("users", "admin", "invoices") + "/clone";

      const invoiceNumber = isProject
        ? projectInvoicesCount + 1
        : generalInvoicesCount + 1;

      await api.post(endpoint, {
        invoiceId: invoice._id,
        invoiceNumber,
      });

      toast.success("Invoice cloned successfully!");
      fetchInvoices(); // refresh the list
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to clone invoice");
    }
  };

  {
    loading && (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }
  const STATUS_OPTIONS = [
    { label: "Draft", value: "Draft" },
    { label: "Sent", value: "Sent" },
    // {label: 'Partial', value: 'Partial'},
    { label: "Paid", value: "Paid" },
    { label: "Cancelled", value: "Cancelled" },
  ];
  const handleStatusChange = async (invoice, newStatus) => {
    try {
      const endpoint =
        invoice.invoiceType === "generalInvoice"
          ? getRoute("users", "admin", "invoices", false, true)
          : getRoute("users", "admin", "projectInvoices", false, true);

      await api.patch(endpoint, {
        id: invoice._id,
        status: newStatus,
      });

      toast.success("Status updated");
      fetchInvoices();
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to update status");
    }
  };
  const handleInvoiceStatusChange = (value) => {
    setStatusFilter(value);
  };

  const STATUS_COLORS = {
    Draft: {
      bg: "#F3F4F6",
      text: "#374151",
      border: "#D1D5DB",
    },
    Sent: {
      bg: "#DBEAFE",
      text: "#1D4ED8",
      border: "#93C5FD",
    },
    // Partial: {
    //   bg: '#FEF3C7',
    //   text: '#92400E',
    //   border: '#FCD34D',
    // },
    Paid: {
      bg: "#DCFCE7",
      text: "#166534",
      border: "#86EFAC",
    },
    Cancelled: {
      bg: "#FEE2E2",
      text: "#991B1B",
      border: "#FCA5A5",
    },
  };

  return (
    <>
      {!companyInfo === true && (
        <div className="flex items-center gap-3 bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 m-3 mb-0 rounded-2xl shadow-sm">
          <div className="flex items-center justify-center min-w-6 h-6 rounded-full bg-blue-100 text-blue-600 font-bold">
            i
          </div>
          <p className="text-sm md:text-base">
            {/* <span className="font-semibold underline cursor-pointer"> */}
            Add{" "}
            <span
              className="ml-1 font-semibold underline cursor-pointer"
              role="button"
              onClick={toggleModal}
            >
              Company Info
            </span>{" "}
            {/* </span>{' '} */}
            to populate in invoices.
          </p>
        </div>
      )}
      <div className="min-h-screen flex flex-col p-3 gap-2 overflow-hidden font-customFont">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div style={{ fontFamily: "Noto Serif, sans-serif" }}>
            <h1 className="font-bold text-lg md:text-xl">Invoice Management</h1>
            <p className="text-xs text-gray-500 font-semibold">
              Manage your project and general invoices
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto mt-3 md:mt-0">
            <button
              className="text-black border border-[#DCE3E3] bg-white px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto"
              onClick={handleRefresh}
            >
              <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
            </button>
            <button
              className={`text-black border px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto ${
                filteredInvoices.length === 0
                  ? "border-gray-300 bg-gray-200 cursor-not-allowed"
                  : "border-[#DCE3E3] bg-white hover:bg-gray-100"
              }`}
              onClick={handleDownloadPDF}
              disabled={filteredInvoices.length === 0}
            >
              <img src="../icons/Download.svg" className="w-5" alt="Download" />
              <span className="ms-2">Download PDF</span>
            </button>
            <button
              className="bg-themeGradient text-white hover:bg-themeGradientHover border border-[#DCE3E3] px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto"
              onClick={handleNewInvoiceClick}
            >
              <i className="fa-solid fa-plus text-lg"></i>
              <span className="ms-2">New Invoice</span>
            </button>
          </div>
        </div>
        <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {/* Total Invoices Card */}
          <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                  <i className="fas fa-file-invoice text-white text-md"></i>
                </div>
                <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                  Total Invoices
                </p>
              </div>
            </div>
            <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
              <span>{totalInvoicesCount}</span>
            </p>
            <p className="text-blue-600 text-xs mt-1 font-medium">
              All invoices in system
            </p>
          </div>
          {/* Project Invoices Card */}
          <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                  <i className="fas fa-project-diagram text-white text-md"></i>
                </div>
                <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                  Project Invoices
                </p>
              </div>
            </div>
            <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
              <span>{projectInvoicesCount}</span>
            </p>
            <p className="text-green-600 text-xs mt-1 font-medium">
              Project based invoices
            </p>
          </div>
          {/* General Invoices Card */}
          <div className="group relative overflow-hidden border border-gray-200 bg-gradient-to-br from-gray-50 via-white to-gray-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gray-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-gray-500 to-gray-700 flex items-center justify-center shadow-md">
                  <i className="fas fa-receipt text-white text-md"></i>
                </div>
                <p className="text-gray-700 text-sm font-semibold uppercase tracking-wide">
                  General Invoices
                </p>
              </div>
            </div>
            <p className="text-gray-900 text-3xl font-bold mt-2 relative z-10">
              <span>{generalInvoicesCount}</span>
            </p>
            <p className="text-gray-600 text-xs mt-1 font-medium">
              Standard Invoices
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:space-x-2">
          <div className="flex flex-col md:w-1/6">
            <DatePicker
              id="filterDate"
              value={filterDate ? dayjs(filterDate) : null}
              onChange={(date, dateString) =>
                handleFilterDateChange(dateString)
              }
              className={`border border-gray-300 rounded-md py-1 px-2 w-full ${
                filterDate ? "ring-1 ring-blue-500 rounded-md" : ""
              }`}
            />
          </div>
          <div className="flex flex-col md:w-1/6 mb-3 md:mb-0">
            <Select
              defaultValue="All"
              id="filterType"
              onChange={handleInvoiceTypeChange}
              className="w-full"
              value={invoiceType}
            >
              <Option value="">All Invoice</Option>
              <Option value="generalInvoice">General Invoice</Option>
              <Option value="projectInvoice">Project Invoice</Option>
            </Select>
          </div>
          <div className="flex flex-col md:w-1/6 mb-3 md:mb-0">
            <Select
              defaultValue=""
              onChange={handleInvoiceStatusChange}
              className="w-full"
              value={statusFilter}
            >
              <Option value="">All Status</Option>
              <Option value="Draft">Draft</Option>
              <Option value="Sent">Sent</Option>
              {/* <Option value="Partial">Partial</Option> */}
              <Option value="Paid">Paid</Option>
              <Option value="Cancelled">Cancelled</Option>
            </Select>
          </div>
        </div>
        {!loading && (
          <>
            <div className="relative w-full">
              {/* HORIZONTAL SCROLL */}
              <div className="overflow-x-auto">
                <div className="min-w-[800px] space-y-2">
                  {/* ================= HEADER ================= */}
                  <div className="rounded-lg border border-[#D5D7DA] shadow-sm bg-[#E9EAEB]">
                    <table className="w-full table-fixed">
                      <thead className="text-[#535862] font-semibold">
                        <tr>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Invoice No
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Project
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Company
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Customer Name
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Type
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Invoice Date
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Amount
                          </th>
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase">
                            Status
                          </th>
                          <th
                            className="px-4 sm:px-6 py-3 text-center text-xs uppercase"
                            colSpan={2}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>

                  {/* ================= BODY ================= */}
                  <div className="max-h-[520px] overflow-y-auto rounded-lg border border-[#D5D7DA] shadow-md bg-white">
                    <table className="w-full table-fixed">
                      <tbody className="divide-y divide-gray-200 text-[#535862]">
                        {filteredInvoices.length === 0 ? (
                          <tr>
                            <td colSpan={8}>
                              <div className="flex flex-col items-center justify-center my-20">
                                <Empty description="No invoice found." />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          filteredInvoices.map((invoice) => {
                            const { totalAfterDiscount } =
                              calculateInvoiceDetails(invoice);

                            const isProject =
                              invoice.invoiceType === "projectInvoice";
                            const statusStyle =
                              STATUS_COLORS[invoice.status] || {};

                            return (
                              <tr key={invoice._id}>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {invoice.number}
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {isProject ? invoice?.project?.name : "-"}
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {isProject
                                    ? invoice.project?.clientCompany
                                    : invoice.customerCompany}
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {isProject
                                    ? invoice.project?.clientName
                                    : invoice.customerName}
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  <span
                                    className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                      isProject
                                        ? "bg-fuchsia-100 text-fuchsia-800"
                                        : "bg-[#FEF3C7] text-[#92400E]"
                                    }`}
                                  >
                                    {isProject ? "Project" : "General"}
                                  </span>
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {formatDate(invoice.date)}
                                </td>
                                <td className="px-4 sm:px-6 py-4 text-sm">
                                  {invoice.currency.symbol}{" "}
                                  {totalAfterDiscount
                                    .toFixed(2)
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                <td className="px-4 py-4 text-sm">
                                  <Select
                                    value={invoice.status}
                                    size="small"
                                    className={`w-20 status-select status-${invoice.status.toLowerCase()}`}
                                    onChange={(value) =>
                                      handleStatusChange(invoice, value)
                                    }
                                    options={STATUS_OPTIONS}
                                    disabled={invoice.status === "Cancelled"}
                                  />
                                </td>
                                <td className="py-4" colSpan={2}>
                                  <div className="flex gap-2 justify-center">
                                    <button
                                      className="w-8 h-8 bg-green-100 hover:bg-green-200 text-green-600 rounded-lg flex items-center justify-center transition-colors"
                                      onClick={() => handleViewInvoice(invoice)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    <button
                                      className="w-8 h-8 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded-lg flex items-center justify-center transition-colors"
                                      onClick={() => handleEditInvoice(invoice)}
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                      className="w-8 h-8 bg-yellow-100 hover:bg-yellow-200 text-yellow-600 rounded-lg flex items-center justify-center transition-colors"
                                      onClick={() =>
                                        handleCloneInvoice(invoice)
                                      }
                                    >
                                      <i className="fas fa-clone"></i>
                                    </button>
                                    <Popconfirm
                                      title="Are you sure you want to delete this invoice?"
                                      onConfirm={() =>
                                        handleDeleteInvoice(invoice)
                                      }
                                      okText="Yes"
                                      cancelText="No"
                                    >
                                      <button className="w-8 h-8 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg flex items-center justify-center transition-colors">
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    </Popconfirm>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <CustomModal
        isOpen={isOpen}
        onClose={toggleModal}
        modalTitle="Update Company Info"
      >
        <CompanyInfo companyId={companyId} onClose={toggleModal} />
      </CustomModal>
    </>
  );
};

export default Invoice;
